import { lazy } from "react";
import Loadable from "app/components/Loadable";
import OperationalRouteGuard from "app/components/operational-workspace/OperationalRouteGuard";

const PatientTokenList = Loadable(lazy(() => import("./PatientTokenQueue")));
const GenerateTokenPage = Loadable(lazy(() => import("../generate-token/GenerateTokenPage")));

const PatientTokenListRoutes = [
  {
    path: "/patients/patient-token",
    element: (
      <OperationalRouteGuard moduleId="PATIENT_TOKEN">
        <PatientTokenList />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/patients/generate-token",
    element: (
      <OperationalRouteGuard moduleId="PATIENT_TOKEN">
        <GenerateTokenPage />
      </OperationalRouteGuard>
    ),
  },
];

export default PatientTokenListRoutes;
